import LangEnum from '../../../lang/LangEnum';
import OrderBillingForecastPreOrderType from '../../orders/enums/order-billing-forecast/order-billing-forecast-pre-order-type.enum';
import OrderBillingForecastReadyForDeliveryType from '../../orders/enums/order-billing-forecast/order-billing-forecast-ready-for-delivery-type.enum';

export const getOrderBillingForecastReadyForDeliveryTypeEnum = (
  rule: OrderBillingForecastReadyForDeliveryType,
): LangEnum => {
  const mapping: Record<OrderBillingForecastReadyForDeliveryType, LangEnum> = {
    [OrderBillingForecastReadyForDeliveryType.MANUAL_INPUT]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_MANUAL_INPUT,
    [OrderBillingForecastReadyForDeliveryType.CALCULATED_FROM_ORDER_DATE]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_CALCULATED_FROM_ORDER_DATE,
    [OrderBillingForecastReadyForDeliveryType.CALCULATED_FROM_INTEGRATION_DATE]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_CALCULATED_FROM_INTEGRATION_DATE,
  };

  return mapping[rule];
};

export const getOrderBillingForecastPreOrderTypeEnum = (
  rule: OrderBillingForecastPreOrderType,
): LangEnum => {
  const mapping: Record<OrderBillingForecastPreOrderType, LangEnum> = {
    [OrderBillingForecastPreOrderType.MANUAL_INPUT]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_MANUAL_INPUT,
    [OrderBillingForecastPreOrderType.CALCULATED_FROM_ORDER_DATE]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_CALCULATED_FROM_ORDER_DATE,
    [OrderBillingForecastPreOrderType.USE_DELIVERY_WINDOW_START_DATE]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_USE_DELIVERY_WINDOW_START_DATE,
    [OrderBillingForecastPreOrderType.USE_DELIVERY_WINDOW_END_DATE]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_USE_DELIVERY_WINDOW_END_DATE,
    [OrderBillingForecastPreOrderType.CALCULATED_FROM_INTEGRATION_DATE]:
      LangEnum.GENERAL_SETTINGS_ORDER_BILLING_FORECAST_RULE_CALCULATED_FROM_INTEGRATION_DATE,
  };

  return mapping[rule];
};
